export const COMISSOES = [
    { label: 'Comissão de Licitação 01', value: 'Comissão de Licitação 01' },
    { label: 'Comissão de Licitação 02', value: 'Comissão de Licitação 02' },
    { label: 'Comissão de Licitação 03', value: 'Comissão de Licitação 03' },
    { label: 'Comissão de Licitação 04', value: 'Comissão de Licitação 04' },
    { label: 'Comissão de Licitação 05', value: 'Comissão de Licitação 05' }
];



// WEBPACK FOOTER //
// ./src/app/_mocks/comissoes.ts